import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../environments/environment.development";
import { Observable } from "rxjs";
import { constantvalues } from "../../const";
import { DtoUserProfile, DtoUserReportView } from "../../models/userProfile.model";

@Injectable({
    providedIn: 'root'
})

export class PowerBiReportService{
    baseURL: string;    
    constructor(private httpClient: HttpClient) {
        this.baseURL = environment.gatewayUrl; 
    }

    getEmbedToken(tokenDetails: any): Observable<any> {
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.POWER_BI}/embed-token`, tokenDetails);
    }

    getEmbedUrl(tokenDetails: any): Observable<any> {
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.POWER_BI}/embed-url/${tokenDetails.reportId}`, tokenDetails);
    }

    getEmbedDetails(tokenDetails: any): Observable<any> {
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.POWER_BI}/embed-details`, tokenDetails);
    }

    getApiUrl(): string {
        return `${this.baseURL}${constantvalues.API_URL.POWER_BI}`;
    }
    
    getAllReports(): Observable<any>
    {
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.POWER_BI_GET_REPORT_ITEMS}`);
    }
    
    getCatalogItems(): Observable<any>
    {
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.POWER_BI_GET_CATALOG}`);
    }

    
    GetUserPreferenceProfile(userId: number): Observable<any>{
        return this.httpClient
            .get(`${this.baseURL}${constantvalues.API_URL.GET_USER_PROFERENCE_PROFILE}/${userId}`);
    }

    SaveUserPreferenceProfile(userId: number, dtoUserProfile: DtoUserProfile): Observable<any>
    {
        return this.httpClient
            .put(`${this.baseURL}${constantvalues.API_URL.SAVE_USER_PROFERENCE_PROFILE}/${userId}`,
                dtoUserProfile
            );
    }
    
    GetUserReportView(reportViewId: number): Observable<any>{
        var url = `${this.baseURL}${constantvalues.API_URL.GET_USER_REPORT_VIEW}/${reportViewId}`;
       
        return this.httpClient
            .get(url);
    }

    GetUserReportViews(userId: number, subcategoryId: number|null, includeShared:boolean): Observable<any>{
        var url = `${this.baseURL}${constantvalues.API_URL.GET_USER_REPORT_VIEWS}/${userId}`;
        if(subcategoryId!=null){
            url = `${url}/${subcategoryId}`;
        }

        if(includeShared!=null){
            url = `${url}?includeShared=${includeShared}`;
        }
        
        return this.httpClient
            .get(url);
    }
      
    SaveUserReportView(reportView: DtoUserReportView): Observable<any>{
        return this.httpClient
            .post(`${this.baseURL}${constantvalues.API_URL.SAVE_USER_REPORT_VIEWS}`,
                reportView
            );
    }

    DeleteUserReportView(userReportViewId: number): Observable<any>{
        return this.httpClient
            .delete(`${this.baseURL}${constantvalues.API_URL.DELETE_USER_REPORT_VIEW}/${userReportViewId}`);
    }

}